import { CheckCircle, XCircle, Info, X } from 'lucide-react';
import { useToastStore } from '@/stores/toastStore';

export default function ToastContainer() {
  const { toasts, removeToast } = useToastStore();
  if (!toasts.length) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[100] space-y-2">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`flex items-center gap-2 px-4 py-2.5 rounded-lg shadow-glow text-sm animate-[slideIn_0.2s_ease] ${
            t.type === 'success'
              ? 'bg-success/10 border border-success/30 text-success'
              : t.type === 'error'
                ? 'bg-error/10 border border-error/30 text-error'
                : 'bg-brand/10 border border-brand/30 text-brand'
          }`}
        >
          {t.type === 'success' && <CheckCircle className="w-4 h-4 flex-shrink-0" />}
          {t.type === 'error' && <XCircle className="w-4 h-4 flex-shrink-0" />}
          {t.type === 'info' && <Info className="w-4 h-4 flex-shrink-0" />}
          <span>{t.message}</span>
          <button onClick={() => removeToast(t.id)} className="ml-2 opacity-60 hover:opacity-100">
            <X className="w-3 h-3" />
          </button>
        </div>
      ))}
    </div>
  );
}
